exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.margin-l[data-v-69e6ef1d]{\n  margin-left:1rem;\n}\n.margin-y[data-v-69e6ef1d]{\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n.double-label-container[data-v-69e6ef1d]{\n  display: flex;\n  flex-direction: column;\n  flex:1;\n}\n.uploaded-items[data-v-69e6ef1d] {\n  background: #e3e3e3;\n  margin: 0 20px;\n  padding: 4px 10px;\n  border-radius: 6px;\n  position: relative;\n}\n", ""]);

// exports
